
import filters from "@/filters";
import { Component, Vue } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import AppFooter from "@/components/AppFooter.vue";
import carousel from "vue-owl-carousel";
import { State } from "vuex-class";
import AppNavbarLanding from "@/components/AppNavbarLanding.vue";
import { WHATSAPP_LINK } from "@/constants/misc.constant";

@Component({
  components: {
    AppNavbarLanding,
    AppFooter,
    AppLayout,
    carousel,
  },
  filters,
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "Job fair, Career fair, Employment fair, Career expo, Job fair near me, Virtual job fair, Career fair opportunities, Job fair preparation, Job fair interviews, Bursa kerja, Pameran karir, Job fair Indonesia, Pameran pekerjaan, Bursa kerja online, Job fair virtual, Tips job fair, Persiapan job fair, Bursa kerja kampus, Peluang job fair, Pameran karir online",
      },
    ],
  },
})
export default class Home extends Vue {
  @State("locale")
  private locale!: string;

  private waLink = WHATSAPP_LINK;
  private impacts = [
    {
      image: require("@/assets/images/impact-story-1.png"),
      name: "Nathalia Ayyara",
      school: "SMKN 3 Kota Serang",
      text_en: `"Attending the Job Fair organized by Career Support was one of the best decisions I made for my career. I not only found potential employers but also gained a deeper understanding of the current job market trends. It significantly increased my chances of securing employment."`,
      text_id: `"Karna Job Fair, saya mendapatkan kesempatan untuk bertemu langsung dengan berbagai perusahaan ternama dan mendiskusikan peluang karier saya di perusahaan mereka!"`,
    },
    {
      image: require("@/assets/images/impact-story-2.png"),
      name: "Putri Alsa Azzafira",
      school: "SMKN 1 Cikande",
      text_en: `"The Career Support Job Fair was an invaluable experience. I not only expanded my professional network but also discovered job openings that perfectly matched my skills and interests. It definitely opened doors to new career prospects."`,
      text_id: `"Berkat Job Fair, saya berhasil menemukan pekerjaan impian saya dengan mudah dan tanpa ribet!"`,
    },
    {
      image: require("@/assets/images/impact-story-3.png"),
      name: "Andrian Pradipta",
      school: "SMK Perguruan Cikande",
      text_en: `"Attending the Career Support Job Fair was a game-changer for me. I landed multiple job interviews and even secured a position in my dream company. The opportunities presented were diverse and abundant!"`,
      text_id: `"Terima Kasih Career Support! Saya bisa langsung ngobrol bareng banyak perusahaan top dan dapetin info penting tentang lowongan mereka."`,
    },
  ];
  private get clientSays() {
    return [
      {
        image: require("@/assets/images/client-say-1.png"),
        name: "Sukarno, ST,. M.M",
        position: `${this.$t(
          "principal_of"
        )} SMK Dinamika Pembangunan 1 Jakarta`,
        text: `"${this.$t("client_say_1")}"`,
      },
      {
        image: require("@/assets/images/client-say-2.png"),
        name: "Ade Susianti, M.Pd",
        position: `${this.$t("principal_of")} SMKN 3 Kota Serang`,
        text: `"${this.$t("client_say_2")}"`,
      },
      {
        image: require("@/assets/images/client-say-3.png"),
        name: "Jaenudin, M.Pd",
        position: `${this.$t("principal_of")} SMKN 1 Cikande`,
        text: `"${this.$t("client_say_3")}"`,
      },
    ];
  }

  private get isEn() {
    return this.locale === "en";
  }

  private get partners() {
    return [
      {
        name: this.isEn ? "Institution<br/>Partners" : "Mitra<br/>Lembaga",
        images: Array.from({ length: 10 }, (_, i) => i + 1).map((value) =>
          require(`@/assets/images/logo-government-${value}.png`)
        ),
      },
      {
        name: this.isEn ? "School<br/>Partners" : "Mitra<br/>Sekolah",
        images: Array.from({ length: 14 }, (_, i) => i + 1).map((value) =>
          require(`@/assets/images/logo-school-${value}.png`)
        ),
      },
      {
        name: this.isEn ? "Company<br/>Partners" : "Mitra<br/>Perusahaan",
        images: Array.from({ length: 10 }, (_, i) => i + 1).map((value) =>
          require(`@/assets/images/logo-company-${value}.png`)
        ),
      },
    ];
  }
}
